export default "__VITE_ASSET__QOPti7sl__"